/* src/app/webhook-creator/webhook-creator/webhook-edit/webhook-debug-log/webhook-debug-log-item/webhook-debug-log-item.component.scss */
.log-item {
  background-color: black;
  color: whitesmoke;
  font-weight: 500;
  padding: 20px;
  border-radius: 16px;
  border-style: solid;
  overflow: auto;
}
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
/*# sourceMappingURL=webhook-debug-log-item.component.css.map */
